"use client";

import { c as _c } from "react/compiler-runtime";
import { useEffect } from "react";
import { useSnapshot } from "valtio";
import { ClockActions, ClockState } from "../stores/clockStore";
export function useClock() {
  const $ = _c(1);
  const {
    date
  } = useSnapshot(ClockState);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = [];
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  useEffect(_temp, t0);
  return date;
}
function _temp() {
  ClockActions.startClock();
}